import { Box, Typography, TextField, Button } from '@mui/material';

function HeroSection({ email, setEmail, loading, onSubmit }) {
  return (
    <>
      {/* Hero Background Section - Full bleed wrapper */}
      <Box
        component="section"
        className="hero"
        sx={{
          position: 'relative',
          width: '100vw',
          marginLeft: 'calc(50% - 50vw)',
          marginRight: 'calc(50% - 50vw)',
          '--layout-top-offset': { xs: '120px', sm: '140px', md: '160px' },
          marginTop: 'calc(-1 * var(--layout-top-offset))',
          marginBottom: 0,
          paddingTop: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: { xs: 4, sm: 5, md: 6 },
          backgroundImage: 'url(/Home/paisaje.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(250, 250, 248, 0.52) 0%, rgba(245, 245, 240, 0.52) 100%)',
            pointerEvents: 'none',
            zIndex: 0,
          },
          overflow: 'hidden',
          mb: { xs: 4, sm: 5, md: 6 },
        }}
      >
        {/* Hero Content - Text over background (centered container) */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: { xs: '100%', sm: '1100px', md: '1200px' },
            mx: 'auto',
            px: { xs: 2, sm: 3, md: 4 },
            pt: { xs: 9, sm: 12, md: 14 },
            pb: { xs: 2.5, sm: 3, md: 3.5 },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: 'text.primary',
              mb: { xs: 1.5, sm: 2 },
              fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
              fontWeight: 700,
              lineHeight: { xs: 1.25, sm: 1.2 },
              textAlign: 'center',
            }}
          >
            Cada compra deja una huella
          </Typography>

          <Typography
            variant="h4"
            sx={{
              color: 'text.primary',
              mb: { xs: 2, sm: 2.5 },
              fontSize: { xs: '1.4rem', sm: '1.75rem', md: '2rem' },
              fontWeight: 600,
              lineHeight: { xs: 1.4, sm: 1.3 },
              textAlign: 'center',
            }}
          >
            En Huelmu, la tuya activa un proyecto ambiental
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              mt: { xs: 2, sm: 3 },
              mb: 0,
              fontSize: { xs: '1rem', sm: '1.15rem', md: '1.25rem' },
              fontWeight: 400,
              lineHeight: { xs: 1.6, sm: 1.5 },
              textAlign: 'center',
            }}
          >
            Consumo consciente con impacto trazable
          </Typography>
        </Box>
      </Box>

      {/* Rest of hero content (outside background) */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'relative',
          maxWidth: { xs: '100%', sm: '1180px', md: '1200px' },
          mx: 'auto',
          px: { xs: 2, sm: 3, md: 5 },
          width: '100%',
        }}
      >

      <Box
        id="proximamente"
        sx={{
          textAlign: 'center',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          maxWidth: { xs: '100%', sm: '620px', md: '650px' },
          mx: 'auto',
          position: 'relative',
          zIndex: 1,
          px: { xs: 0, sm: 0 },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' },
            fontWeight: 400,
            lineHeight: { xs: 1.6, sm: 1.7 },
            textAlign: 'left',
            mt: 0,
            mb: { xs: 1, sm: 1 },
            px: { xs: 2, sm: 0 },
          }}
        >
          <Box component="span" sx={{ fontWeight: 600 }}>
            ¡Próximamente!
          </Box>
          {' '}Productos conscientes para usar o regalar. Cada compra activa un proyecto ambiental en Chile, escanea el QR y sigue tu impacto.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', sm: '500px' },
          mx: 'auto',
          px: { xs: 2, sm: 0 },
          mt: { xs: 4, sm: 5 },
          mb: { xs: 2, sm: 3 },
        }}
      >
        <Box
          component="form"
          id="enterarme"
          onSubmit={onSubmit}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr auto' },
            gap: { xs: 1.5, sm: 2 },
            alignItems: 'stretch',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              backgroundColor: 'white',
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: '8px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              '&:focus-within': {
                borderColor: 'rgba(0, 0, 0, 0.4)',
              },
            }}
          >
            <TextField
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              sx={{
                width: '100%',
                boxSizing: 'border-box',
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                  borderRadius: 0,
                  overflow: 'visible',
                  width: '100%',
                  boxSizing: 'border-box',
                  backgroundColor: 'transparent',
                  boxShadow: 'none !important',
                  outline: 'none !important',
                  border: 'none !important',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important',
                    display: 'none',
                  },
                  '& .MuiOutlinedInput-input': {
                    borderRadius: 0,
                    boxShadow: 'none !important',
                    outline: 'none !important',
                    border: 'none !important',
                    backgroundColor: 'transparent',
                    appearance: 'none',
                    padding: { xs: '14px 16px', sm: '16px 20px' },
                    '&:focus': {
                      boxShadow: 'none !important',
                      outline: 'none !important',
                      border: 'none !important',
                    },
                    '&:focus-visible': {
                      boxShadow: 'none !important',
                      outline: 'none !important',
                      border: 'none !important',
                    },
                  },
                  '& fieldset': {
                    border: 'none !important',
                    display: 'none !important',
                  },
                  '&:hover fieldset': {
                    border: 'none !important',
                    display: 'none !important',
                  },
                  '&.Mui-focused': {
                    boxShadow: 'none !important',
                    outline: 'none !important',
                    border: 'none !important',
                    '& fieldset': {
                      border: 'none !important',
                      display: 'none !important',
                    },
                  },
                  '&.Mui-focusVisible': {
                    boxShadow: 'none !important',
                    outline: 'none !important',
                    border: 'none !important',
                  },
                  '&.Mui-error fieldset': {
                    border: 'none !important',
                    display: 'none !important',
                  },
                },
              }}
            />
          </Box>
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              px: { xs: 3, sm: 4 },
              py: { xs: 1.25, sm: 1.5 },
              backgroundColor: 'primary.main',
              whiteSpace: 'nowrap',
              border: 'none',
              outline: 'none',
              overflow: 'hidden',
              borderRadius: '8px',
              width: { xs: '100%', md: 'auto' },
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
              '&:disabled': {
                backgroundColor: 'secondary.light',
              },
              fontSize: { xs: '0.95rem', sm: '1rem' },
              '& .MuiButtonBase-root': {
                overflow: 'hidden',
                borderRadius: '8px',
              },
              '& .MuiButton-label': {
                borderRadius: '8px',
              },
              '& .MuiTouchRipple-root': {
                borderRadius: '8px',
              },
              '&::before': {
                display: 'none',
              },
              '&::after': {
                display: 'none',
              },
            }}
          >
            Quiero enterarme
          </Button>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: 'text.disabled',
          fontSize: { xs: '0.85rem', sm: '0.9rem' },
          px: { xs: 2, sm: 0 },
          textAlign: { xs: 'left', sm: 'center' },
        }}
      >
        Te avisaremos cuando lancemos los primeros productos.
      </Typography>
      </Box>
    </>
  );
}

export default HeroSection;
